import { Accordion } from './accordion.component';

export * from './accordion.component';
export default Accordion;

Accordion.define('der-ui-accordion');

declare global {
    interface HTMLElementTagNameMap {
        'der-ui-accordion': Accordion;
    }
}
